import React from 'react';
import cn from 'classnames';
import {
    AssortmentRecord,
    AssortmentDetails,
    AssortmentStoreOptionCounts,
    Material,
    canUpdateDigitalBuyplan,
    AssortedBy,
    ChannelRole,
} from 'buyplan-common';
import './AssortmentDetailCheckbox.scss';
import { useSelector } from '../../store/reducers';
import useHasChannelRole from '../../selectors/useHasChannelRole';

export interface AssortmentDetailCheckboxProps {
    clusterId: string;
    material: Material;
    record?: AssortmentDetails;
    storeOptionCount: AssortmentStoreOptionCounts;
    onChange: (record: AssortmentRecord, clusterId: string) => void;
    assortAllLoading: boolean;
    isDisabled: boolean;
}

function AssortmentDetailCheckbox({
    clusterId,
    material,
    storeOptionCount,
    record,
    onChange,
    isDisabled = false,
    assortAllLoading,
}: AssortmentDetailCheckboxProps) {
    const checked = !!record;
    const updating = record && record.isUpdating;

    const isValueChanged = record && !record.isFromMerchandiseFile;

    const assortedBy = record && record.assortedBy;
    const id = `${storeOptionCount.number}_${material.materialCode}`;
    const { activeChannelId } = useSelector(({ user }) => user.settings);
    const isReadOnlyUser = useHasChannelRole(ChannelRole.readOnly);

    const shouldDisable = () => {
        const storeNumber = storeOptionCount.number;
        const { typeOfOrder } = material;
        return !canUpdateDigitalBuyplan(activeChannelId, storeNumber, typeOfOrder) || isReadOnlyUser;
    };

    return (
        <div className="AssortmentDetailCheckbox" title={`${material.materialCode} - ${storeOptionCount.name}`}>
            <label
                htmlFor={id}
                className={cn('AssortmentDetailCheckbox__label', {
                    'AssortmentDetailCheckbox__label--isPlannerAssortment':
                        isValueChanged && assortedBy === AssortedBy.planner,
                    'AssortmentDetailCheckbox__label--isPartnerAssortment':
                        isValueChanged && assortedBy === AssortedBy.partner,
                })}
            >
                <input
                    id={id}
                    type="checkbox"
                    checked={checked}
                    disabled={updating || shouldDisable() || assortAllLoading || isDisabled}
                    onChange={() =>
                        onChange(
                            {
                                storeId: storeOptionCount.storeId,
                                storeNumber: storeOptionCount.number,
                                materialCode: material.materialCode,
                                clusterId,
                            },
                            clusterId
                        )
                    }
                />
                <div className="checkmark" />
            </label>
        </div>
    );
}

export default AssortmentDetailCheckbox;
